;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.7";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from '@sentry/nextjs'
import { sentryDsn, sentryEnabled, sentryEnvironment, sentryTracesSampleRate } from '@src/lib/sentryShared'
import { initBotId } from 'botid/client/core'

// Define the paths that need bot protection.
// These are paths that are routed to by your app.
// These can be:
// - API endpoints (e.g., '/api/checkout')
// - Server actions invoked from a page (e.g., '/dashboard')
// - Dynamic routes (e.g., '/api/create/*')

initBotId({
  protect: [
    {
      path: '/login',
      method: 'GET',
    },
  ],
})

// Client Sentry init — runs when a page loads in the browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
Sentry.init({
  dsn: sentryDsn,
  enabled: sentryEnabled,
  environment: sentryEnvironment,

  integrations: [Sentry.replayIntegration()],

  tracesSampleRate: sentryTracesSampleRate,
  enableLogs: true,

  // 10% of normal sessions; 100% of sessions that hit an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
